import { InteractionEvent, Sprite } from 'pixi.js';
import { Game, Scene, Store, TextureFactory } from '../core';
import { parse } from 'querystring';
import ShareUI from '../ui/ShareUI';

class ShareScene extends Scene {
  private ui: ShareUI;

  constructor(game: Game) {
    super(game);

    this.camera.setOffset({ x: 0, y: 0 });
    this.camera.setTargetPosition({ x: 540, y: 960 }, true);

    const sprite = new Sprite(TextureFactory.instance.getSingleTexture('/textures/bg/bg_main.png'));
    sprite.width = 1080;
    sprite.height = 1920;
    this.stage.addChild(sprite);

    this.ui = new ShareUI();
    this.ui.on('home', () => {
      const button = document.getElementById('sharebtn') as HTMLElement;
      button.style.display = 'none';
      window.location.replace('/');
    });

    this.ui.scale.set(this.camera.zoom);
    this.ui.x = this.game.width / 2;
    this.ui.y = this.game.height / 2;

    this.container.addChild(this.ui);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_hash, querystring] = window.location.hash.split('?');
    const { d } = parse(querystring);
    const data = Store.instance.d(d as string, '89Gr9JE3HLD0KEMeAsbKCC7XLts5552w');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [stage, score, rank, ...playername] = data.split(',');

    this.ui.setScore(stage, score, Number(rank), (playername || []).join(','));
  }

  public update(elapsed: number): void {
    super.update(elapsed);
  }

  public destroy(): void {
    super.destroy();
  }

  protected pointerdown = (event: InteractionEvent) => {
    //
  };

  protected pointermove = (event: InteractionEvent) => {
    //
  };

  protected pointerup = (event: InteractionEvent) => {
    //
  };

  public onBegin(): void {
    //
  }
}

export default ShareScene;
